var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmplifyColors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "820px",
    height: "700px",
    viewBox: "0 0 820 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Template---App-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-103, -102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Indigo-Ring",
    transform: "translate(103, 102)",
    fill: "color(display-p3 0.157 0.153 0.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410,0 C636.436747,0 820,183.563253 820,410 C820,514.47223 780.925479,609.818117 716.593775,682.220323 L644.649508,575.294487 C677.628213,528.564093 697,471.544308 697,410 C697,251.494277 568.505723,123 410,123 C251.494277,123 123,251.494277 123,410 C123,471.501008 142.344538,528.483857 175.280904,575.195838 L103.304438,682.105725 C39.0333069,609.717522 0,514.41712 0,410 C0,183.563253 183.563253,0 410,0 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Magenta-Ring",
    transform: "translate(144, 143)",
    fill: "color(display-p3 0.510 0.000 0.561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369,0 C572.793073,0 738,165.206927 738,369 C738,459.208543 705.629847,541.856631 651.871498,605.962308 L603.648805,534.295484 C636.627938,487.564904 656,430.544746 656,369 C656,210.494277 527.505723,82 369,82 C210.494277,82 82,210.494277 82,369 C82,430.501008 101.344538,487.483857 134.280904,534.195838 L86.0376892,605.853974 C32.3337003,541.763531 -2.66453526e-15,459.157735 -2.66453526e-15,369 C-2.66453526e-15,165.206927 165.206927,0 369,0 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Picton-Ring",
    transform: "translate(185, 184)",
    fill: "color(display-p3 0.224 0.702 0.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,0 C509.149398,0 656,146.850602 656,328 C656,403.907894 630.214484,473.793259 586.92483,529.374715 L562.648805,493.295484 C595.627938,446.564904 615,389.544746 615,328 C615,169.494277 486.505723,41 328,41 C169.494277,41 41,169.494277 41,328 C41,389.501008 60.3445377,446.483857 93.2809044,493.195838 L68.9945902,529.271212 C25.7535196,473.70651 2.13162821e-14,403.860784 2.13162821e-14,328 C2.13162821e-14,146.850602 146.850602,0 328,0 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Amplify-Icon",
    transform: "translate(1, 0)",
    fill: "color(display-p3 1.000 1.000 1.000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(224, 221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,1 C211.1729,1 138.817219,30.8522801 84.3472124,85.2406809 C29.8772054,139.629082 0,212.010638 0,288.890482 C0,349.617381 18.6986591,407.481732 53.2505293,455.94057 L90.241355,400.325364 C71.7459421,367.406068 60.9738885,329.375081 60.9738885,288.890482 C60.9738885,163.756267 162.800282,61.9313663 288,61.9313663 C413.199718,61.9313663 515.026112,163.756267 515.026112,288.890482 C515.026112,329.375081 504.254058,367.610536 485.555399,400.529831 L522.546224,456.145038 C557.301341,407.6862 576,349.821849 576,289.09495 C576,212.215105 546.122795,139.833549 491.652788,85.4451486 C437.386027,30.8522801 365.030346,1 288,1 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "409.479261 446.40458 372.550459 548.221816 382.087018 581 382.289923 581 382.289923 581 574.238532 581 501.801266 472.012537"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "74.1987337 472.012537 1.76146789 581 193.912982 581 203.449541 548.221816 166.317834 446.40458"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "454.458716 401.122966 288 152.419847 121.541284 401.122966 202.427588 376.579895 231.155469 461.458015 288 277.589509 344.844531 461.458015 373.776156 376.579895"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplifyColors);
export default __webpack_public_path__ + "static/media/amplify-colors.d84918ed8da883a3c605109a2eb106b5.svg";
export { ForwardRef as ReactComponent };